// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3SQHJ","buttons":"RemoveExpirationActionButtons_buttons__WDHnA"};